import localDe from './local-DE.js';
import localAt from './local-AT.js';
import localEn from './local-EN.js';
import localFr from './local-FR.js';
import localSl from './local-SL.js';


export default {
    'en':localEn,
    'de':localDe,
    'fr':localFr,
    'sl':localSl,
    'at':localAt,
}


// WEBPACK FOOTER //
// ./src/localization/translations/index.js